import { req } from './axiosFun';

// 获取报价列表
export function getQuoteList(params) {
    return req('get', '/api/quote/list', params);
}

// 获取报价详情
export function getQuoteDetail(id) {
    return req('get', `/api/quote/detail/${id}`);
}


// WEBPACK FOOTER //
// ./src/api/quote.js